var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAroowSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "50px",
    height: "50px",
    viewBox: "0 0 27.334 27.334",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.834,0.001H1.5c-0.827,0-1.5,0.672-1.5,1.5V8.62c0.502-0.081,1.015-0.135,1.539-0.135h10.242V3.931l10.245,10.246 L11.781,24.425v-5.922H1.539c-0.524,0-1.037,0.053-1.539,0.135v7.195c0,0.826,0.673,1.5,1.5,1.5h24.334c0.828,0,1.5-0.674,1.5-1.5 V1.5C27.334,0.673,26.662,0.001,25.834,0.001z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAroowSearch);
export default __webpack_public_path__ + "static/media/aroowSearch.1ebd39b8619469f15bf30e7e1f851cdf.svg";
export { ForwardRef as ReactComponent };